import React from 'react';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { DeereFetch } from '../../shared/fetch';
import { Loading } from '../Loading';
import { UsersCardItem } from '../UsersCardItem';

import styles from './index.css';
export class UsersCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: []
        };
    }

    componentDidMount() {
        this.getUsers();
    }

    async getUsers() {
        this.setState({
            loading: true
        });

        try {
            this.setState({
                users: await DeereFetch('/api/users', {
                    query: {
                        includePending: true,
                        sort: 'role,asc'
                    }
                })
            });
        } finally {
            this.setState({
                loading: false
            });
        }
    }

    async updateRole(id, role) {
        return await DeereFetch(`/api/users/${id}/role`, {
            method: 'POST',
            query: { role }
        });
    }

    render() {
        return (
            <Paper className={styles.root}>
                <Typography variant="caption">Changes are automatically saved.</Typography>
                <UsersCardItem clearAfterSave={true} editUid={true} onChange={(user) => {
                    this.setState((prevState) => ({
                        users: [...prevState.users, user]
                    }));
                }} style={{ marginTop: 10 }} />
                <div style={{ marginTop: 10, marginBottom: 10 }}>
                    <Divider />
                </div>
                <Loading hideChildren loading={this.state.loading}>
                    {this.state.users.map((user, index) =>
                        <div key={user.id}>
                            <UsersCardItem editUid={user.pending} onChange={(user) => {
                                this.setState((prevState) => ({
                                    users: user
                                        ? prevState.users.map((existingUser, userIndex) =>
                                            (userIndex === index ? user : existingUser))
                                        : prevState.users.filter((_, userIndex) => userIndex !== index)
                                }));
                            }} user={user} />
                            <div style={{ marginTop: 10, marginBottom: 10 }}>
                                <Divider />
                            </div>
                        </div>
                    )}
                </Loading>

            </Paper>
        )
    }
}
